function arrayMoveItemToPosition(arr: any[], fromPosition: number, toPosition: number): any[] {
    if (fromPosition >= 0 && fromPosition < arr.length && toPosition >= 0 && toPosition <= arr.length) {
        const item = arr.splice(fromPosition, 1)[0];

        arr.splice(toPosition, 0, item);
    } else {
        throw new Error('Invalid position');
    }

    return arr;
}

// ----------------------------------------------------------------------------

export default arrayMoveItemToPosition;
